import type {
  Catalogue_SystemSettingsFilter,
  FileTransferFilter,
  OrganizationTenantFilter,
  SubTenantsFilter,
} from '../gql/graphql';

export const coreApiKeys = {
  all: ['core'] as const,
  yearGroups: {
    all: () => [...coreApiKeys.all, 'yearGroups'] as const,
  },
  academicNamespaces: {
    all: () => [...coreApiKeys.all, 'academicNamespaces'] as const,
  },
  programmeStages: {
    all: () => [...coreApiKeys.all, 'programmeStages'] as const,
  },
  allFileTransferList: () => [...coreApiKeys.all, 'fileTransferList'] as const,
  fileTransferList: (filter: FileTransferFilter) =>
    [...coreApiKeys.allFileTransferList(), filter] as const,
  allSettingsValues: () => [...coreApiKeys.all, 'settingsValues'] as const,
  settingsValues: (filter: Catalogue_SystemSettingsFilter) =>
    [...coreApiKeys.allSettingsValues(), filter] as const,
  cmsConfig: () => [...coreApiKeys.all, 'cmsConfig'] as const,
  cmsRequest: (path: string) =>
    [...coreApiKeys.all, 'cmsRequest', path] as const,
  subTenants: (filter: SubTenantsFilter) =>
    [...coreApiKeys.all, 'subTenants', filter] as const,
  organizationTenant: (filter: OrganizationTenantFilter) =>
    [...coreApiKeys.all, 'organizationTenant', filter] as const,
};
